import React from "react";

export default class ChevronUpSVG16X16 extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9L8 5L12 9" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    );
  }
}
